export default {
  getCardsByRank: function (cards) {
    let cardsByRank = {
      '2': [],
      '3': [],
      '4': [],
      '5': [],
      '6': [],
      '7': [],
      '8': [],
      '9': [],
      't': [],
      'j': [],
      'q': [],
      'k': [],
      'a': []
    };

    cards.forEach(function (card) {
      let rank = card[0];

      cardsByRank[rank].push(card);
    });

    return cardsByRank;
  },
  getCardsBySuit: function (cards) {
    let cardsBySuit = {
      c: [],
      s: [],
      h: [],
      d: []
    };

    cards.forEach(function (card) {
      let suit = card[1];
      cardsBySuit[suit].push(card);
    });

    return cardsBySuit;
  },
  checkIfRankIndexesAreSequential: function (rankIndexes) {
    for (let i = 0; i < rankIndexes.length - 1; i++) {
      if (rankIndexes[i] + 1 !== rankIndexes[i + 1]) {
        return false;
      }
    }

    return true;
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/get-info-from-combined-cards/helpers.js